import { toast, ToastContainer } from "react-toastify";
import { Button, CheckBox, TextArea, Input, Text, Heading } from "../../components";
import React, { useState } from "react";

export default function BookADemoSection() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    message: "",
    terms: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Simple validation
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First Name is required.";
    if (!formData.lastName) newErrors.lastName = "Last Name is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    if (!formData.company) newErrors.company = "Company name is required.";
    if (!formData.message) newErrors.message = "Message is required.";
    if (!formData.terms) newErrors.terms = "You must agree to the terms and conditions.";
  
    setErrors(newErrors);
  
    // If there are no errors, proceed with form submission
    if (Object.keys(newErrors).length === 0) {
      try {
        const response = await fetch("/New-Zwilling-Website-PHP/send_book_a_demo.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            company: formData.company,
            message: formData.message,
            terms: formData.terms ? "1" : "0",
          }),
        });
  
        const result = await response.json();
  
        if (result.status === "success") {
          toast.success(result.message);
          // Reset form after successful submission
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            company: "",
            message: "",
            terms: false,
          });
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("There was an error submitting the form. Please try again later.");
      }
    }
  };

  return (
    <div className="mt-[100px] flex flex-col items-center md:px-10">
      <div className="container-xs flex flex-col gap-[62px] px-1.5 sm:gap-[31px] sm:px-5">
        <div className="mr-4 flex flex-col items-center gap-5 md:mr-0">
          <Heading
            size="heading7xl"
            as="h1"
            className="text-[24px] font-bold uppercase tracking-[2.40px] text-colors3 md:text-[22px]"
          >
            get a demo
          </Heading>
          <Heading
            as="h2"
            className="w-[54%] text-center text-[46px] font-bold leading-[69px] text-color_style-01_neutrals-grey800 md:w-full md:text-[42px] sm:text-[36px] sm:leading-10"
          >
            Connect with our team for a consultation.
          </Heading>
          <Text
            size="text11xl"
            as="p"
            className="self-stretch text-center text-[26px] font-normal leading-10 text-muted md:text-[24px] sm:text-[22px]"
          >
            Discover how our solution can help optimize your operations for greater efficiency and smoother compliance.
          </Text>
        </div>
        <form onSubmit={handleSubmit} className="mr-4 flex flex-col gap-[26px] md:mr-0">
          <div className="flex flex-col sm:flex-row gap-5 md:flex-row">
            <div className="flex flex-col gap-5 sm:w-full md:w-full">
              <Input
                size="sm"
                shape="round"
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First name"
                className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
              />
              {errors.firstName && <p className="text-red-500 text-sm">{errors.firstName}</p>}
            </div>
            <div className="flex flex-col gap-5 sm:w-full md:w-full">
              <Input
                size="sm"
                shape="round"
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last name"
                className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
              />
              {errors.lastName && <p className="text-red-500 text-sm">{errors.lastName}</p>}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-5 md:flex-row">
            <div className="flex flex-col gap-5 sm:w-full md:w-full">
              <Input
                size="sm"
                shape="round"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Id"
                className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
              />
              {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
            </div>
            <div className="flex flex-col gap-5 sm:w-full md:w-full">
              <Input
                size="sm"
                shape="round"
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Company name"
                className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
              />
              {errors.company && <p className="text-red-500 text-sm">{errors.company}</p>}
            </div>
          </div>
          <TextArea
            size="sm"
            variant="tarOutlineBluegray500ad"
            shape="round"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            className="w-full rounded-[18px] !border-[1.58px] !border-blue_gray-500_ad px-6 text-gray-600 sm:px-5"
          />
          {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
          <div className="flex items-center justify-between gap-5 sm:flex-col">
            <CheckBox
              name="terms"
              label="I agree to the terms and conditions"
              id="TermsCheckbox"
              checked={formData.terms}
              onChange={handleChange}
              className="gap-2.5 text-[18px] text-indigo-900_01"
            />
            {errors.terms && <p className="text-red-500 text-sm">{errors.terms}</p>}
            <Button
              size="6xl"
              type="submit"
              className="min-w-[194px] rounded-[14px] px-[34px] font-bold tracking-[-0.85px] sm:px-5"
            >
              Submit
            </Button>
          </div>
          <ToastContainer position="top-right" />
        </form>
      </div>
    </div>
  );
}
